import React, { PropsWithChildren } from 'react';
import style from './typography.module.scss';

type AS = Extract<keyof JSX.IntrinsicElements, 'p' | 'span' | 'div' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5'>;

interface Props extends React.ComponentPropsWithoutRef<"div">, TextProps {
  element: AS;
}

export interface TextProps {
  textColor?: "sys-dark-ink-main" |
            "sys-light-ink-main" |
            "sys-light-ink-on-card" |
            "sys-light-ink-link" |
            "sys-light-ink-offset" |
            "sys-dark-ink-offset" |
            "sys-dark-ink-on-primary";

  textSize: "sys-display-large" |
        "sys-display-medium" |
        "sys-display-small" |
        "sys-headline-large" |
        "sys-headline-medium" |
        "sys-headline-small" |
        "sys-title-large" |
        "sys-title-medium" |
        "sys-title-small" |
        "sys-body-large" |
        "sys-body-medium" |
        "sys-body-small" |
        "sys-label-large" |
        "sys-label-medium" |
        "sys-label-small" |
        "sys-tag-large" |
        "sys-tag-medium" |
        "sys-tag-small";

  themeColor?: "text-ink-main" | "text-ink-offset" | "text-ink-primary" | "text-ink-secondary" | "text-ink-on-primary" | "text-ink-on-inverse" | "text-ink-on-card";
}

export const Typography = (props: PropsWithChildren<Props>) => {
  const {element, textColor, themeColor, textSize, className, ...rest} = props;
  const Element = element;

  return (
    <Element
      {...rest}
      className={[
        style[textColor],
        style[textSize],
        themeColor,
        className
      ].join(" ")}
    >
      {props.children}
    </Element>
  )
}
